import React from "react";
import "./Footer.css";
import BrandlyLogo from "../../assets/Footer/BrandlyLogoFooter.png";
import InstagramIcon from "../../assets/Footer/Instagram.png";
import LinkedInIcon from "../../assets/Footer/LinkedIn.png";
import TwitterXIcon from "../../assets/Footer/TwitterX.png";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-body">
          {/* CTA Section */}
          <div className="footer-left">
            <p className="footer-description">
              Elevate your personal brand with
              <br />
              <strong className="highlight">tailored posts, insights, and strategies</strong>
              – built just for you.
            </p>
            <button className="footer-cta" onClick={() => (window.location.href = "/login")}>
              Start For Free
            </button>
          </div>

          {/* Navigation Columns */}
          <div className="footer-columns">
            <div className="footer-column">
              <h4>Navigations</h4>
              <a href="/about">About</a>
              <a href="/pricing">Pricing</a>
              <a href="/blogs">Blogs</a>
              {/* <a href="/influencer">Influencer</a> */}
            </div>
            <div className="footer-column">
              <h4>Mini Tools</h4>
              <a href="/linkedin-video-downloader">LinkedIn Video Downloader</a>
              <a href="/linkedin-headline-generator">LinkedIn Headline Generator</a>
              <a href="/linkedin-summary-generator">LinkedIn Summary Generator</a>
              {/* <a href="/">LinkedIn Carousel Generator</a>
              <a href="/">LinkedIn SSI Score</a>
              <a href="/">Hooks Generator</a> */}
            </div>
            <div className="footer-column">
              <h4>Legal</h4>
              <a href="/privacy-policy">Privacy Policy</a>
              <a href="/contact-us">Contact</a>
              <a href="/terms-and-conditions">Terms & Conditions</a>
            </div>
          </div>
        </div>

        {/* Branding Section */}
        <div className="footer-brand-logo">
          <img src={BrandlyLogo} alt="Brandly Logo" className="footer-logo" />
        </div>

        {/* Separator */}
        <div className="footer-separator"></div>

        {/* Socials & Copyright */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2024 Brandly. All Rights Reserved.
          </p>
          <div className="footer-socials">
            <a href="/">
              <img src={TwitterXIcon} alt="Twitter" />
            </a>
            <a href="/https://www.facebook.com/people/Brandly/61579402638003/">  
              <img src={InstagramIcon} alt="Instagram" />
            </a>
            <a href="https://www.linkedin.com/company/brandly-for-linkedin/">
              <img src={LinkedInIcon} alt="LinkedIn" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
